import { CartAddEvent, CartErrorEvent } from '@theme/events';

const OFFER_FORM_SELECTOR = '.othren-cart-offer__form';

const getSectionIds = () =>
  [...document.querySelectorAll('cart-items-component[data-section-id]')]
    .map((element) => element.dataset.sectionId)
    .filter(Boolean);

const addOfferToCart = async (form) => {
  const button = form.querySelector('button[type="submit"]');
  if (!button || button.disabled) return;

  const originalLabel = button.textContent;
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  button.textContent = 'ADDING…';

  const formData = new FormData(form);
  const sectionIds = getSectionIds();
  if (sectionIds.length) formData.set('sections', sectionIds.join(','));

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });
    const resource = await response.json();

    if (resource.status) {
      document.dispatchEvent(
        new CartErrorEvent(
          form.getAttribute('id') || 'othren-cart-offer',
          resource.message,
          resource.description,
          resource.errors
        )
      );
      button.textContent = 'TRY AGAIN';
      return;
    }

    const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await cartResponse.json();

    document.dispatchEvent(
      new CartAddEvent(cart, String(formData.get('id')), {
        source: 'othren-cart-offers',
        itemCount: Number(formData.get('quantity')) || 1,
        sections: resource.sections,
      })
    );
    button.textContent = 'ADDED';
  } catch (error) {
    console.error('OTHREN cart offer failed', error);
    button.textContent = 'TRY AGAIN';
  } finally {
    window.setTimeout(() => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalLabel;
    }, 1400);
  }
};

document.addEventListener(
  'submit',
  (event) => {
    const form = event.target.closest(OFFER_FORM_SELECTOR);
    if (!form) return;
    event.preventDefault();
    addOfferToCart(form);
  },
  true
);
